import React, { Component } from 'react';

class OnboardingStepNew extends Component {
  render() {
    const { Component, ...rest } = this.props;

    return (
      <div className="onboarding-new__step">
        <Component {...rest} />
      </div>
    );
  }
}

export default OnboardingStepNew;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/OnboardingStepNew.js